import { BaseHttpAdapter } from '~/services/adapters/base-http.adapter';
import {
    IServerSmartField,
    TGetFlowSmartFieldsRequestParams,
    TGetOneComposerSmartFieldsRequestParams,
    TOneComposerSmartFieldKeys,
    TSmartFieldKeys
} from '~/common/SmartFields/server.types';

export class SmartFieldAdapter extends BaseHttpAdapter {
    async getFlowSmartFields({
        flowId,
        isTemplateEditor,
        workspaceId
    }: TGetFlowSmartFieldsRequestParams) {
        return this.apiService.apiRequest<
            Partial<Record<TSmartFieldKeys, IServerSmartField>>
        >({
            method: 'get',
            url: `/api/v2/flow/${flowId}/smart_fields`,
            params: {
                is_template: isTemplateEditor,
                workspace_id: workspaceId
            }
        });
    }

    async getOneComposerSmartFields(
        params: TGetOneComposerSmartFieldsRequestParams = {}
    ) {
        return this.apiService.apiRequest<
            Partial<Record<TOneComposerSmartFieldKeys, IServerSmartField>>
        >({
            method: 'get',
            url: `/api/v2/smart_fields`,
            params
        });
    }
}
